import { io } from "socket.io-client";

const url = process.env.REACT_APP_WS_HOST

export const socket = io(url, {
	autoConnect: false,
});
